var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lote-tempo-progresso"},[_c('div',{staticClass:"progresso",class:_vm.classes,style:(_vm.style)})])
}
var staticRenderFns = []

export { render, staticRenderFns }